var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import { ChartSeriesVisibility } from '@web/components/layout/RechartsItems/ChartSeriesVisibility';
import CustomTooltip from '@web/components/layout/RechartsItems/CustomTooltip';
import { createEdgePositionedBarTooltipContent } from '@web/components/layout/RechartsItems/EdgePositionedBarTooltip';
import LegendItem from '@web/components/layout/RechartsItems/LegendItem';
import { Widget } from '@web/components/layout/Widget';
import { WidgetChartPlotArea } from '@web/components/layout/WidgetChartPlotArea/WidgetChartPlotArea';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { EMAIL_SUMMARY_REPLY_RATE_COLORS_CONFIG, TablesDiffColorsConfig } from '@web/config';
import { trpc } from '@web/lib/trpc';
import { isAiButtonDisabled } from '@web/utility';
import { ComparisonPeriod, navigateToEventsLogFromPeriodChartBarClick } from '@web/utility/chartNavigation';
import { formatChartDayPeriodAxisLabel, getPeriodBarChartLayoutProps, isBarChartRowsEmpty } from '@web/utility/charts';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { ApplicationEnum, EMAIL_SUMMARY_REPLY_RATE_KEYS, InsightTypeEnum } from '@workalizer/shared';
import { formatReplyRateDisplay, getInterval } from '@workalizer/shared/utils';
import { useTranslation } from 'react-i18next';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
export var EmailSummaryReplyRate = function (_a) {
    var userId = _a.userId, orgUnitId = _a.orgUnitId, dateFrom = _a.dateFrom, dateTo = _a.dateTo;
    var t = useTranslation().t;
    var navigateTo = useNavigateTo();
    var _b = trpc.emailSummaryReplyRate.useQuery({
        userId: userId,
        orgUnitId: orgUnitId,
        dateFrom: dateFrom,
        dateTo: dateTo
    }), data = _b.data, isLoading = _b.isLoading, refetch = _b.refetch;
    if (isLoading || !data) {
        return _jsx(Loading, {});
    }
    var interval = getInterval(dateFrom, dateTo);
    var i18nPrefix = 'app.performanceReview.employeePerformanceReview.communicationSection.emailSummaryReplyRate';
    var chartData = data.periods.map(function (period) { return ({
        period: period.period,
        previousPeriodLabel: period.previousPeriodLabel,
        received: period.received,
        opened: period.opened,
        replied: period.replied
    }); });
    var handleBarClick = function (barData, fallbackIndex) {
        navigateToEventsLogFromPeriodChartBarClick({
            chartData: chartData,
            barData: barData,
            fallbackIndex: fallbackIndex,
            stack: ComparisonPeriod.Current,
            app: ApplicationEnum.GMAIL,
            navigateTo: navigateTo,
            dateFrom: dateFrom,
            dateTo: dateTo,
            userId: userId,
            orgUnitId: orgUnitId
        });
    };
    var _c = getPeriodBarChartLayoutProps({
        barGroupCount: chartData.length,
        barsPerGroup: EMAIL_SUMMARY_REPLY_RATE_KEYS.length
    }), barGap = _c.barGap, barSize = _c.barSize, periodXAxis = _c.periodXAxis, periodBarChartMargin = _c.periodBarChartMargin;
    var chartPlotEmpty = isBarChartRowsEmpty(chartData);
    var seriesOrder = __spreadArray([], EMAIL_SUMMARY_REPLY_RATE_KEYS, true);
    var seriesLabelFormatter = function (dataKey) {
        return t("".concat(i18nPrefix, ".series.").concat(dataKey));
    };
    var renderTooltip = createEdgePositionedBarTooltipContent(_jsx(CustomTooltip, { seriesOrder: seriesOrder, seriesLabelFormatter: seriesLabelFormatter, formatValue: function (value) { return String(value); } }), chartData.length);
    var legendItems = [
        {
            key: 'received',
            currentValue: String(data.totals.received.count),
            diffValue: data.totals.received.previous,
            teamAverage: userId ? data.totals.received.teamAverage : undefined
        },
        {
            key: 'opened',
            currentValue: formatReplyRateDisplay(data.totals.opened.count, data.totals.opened.rate),
            diffValue: data.totals.opened.previous,
            teamAverage: userId ? data.totals.opened.teamAverage : undefined
        },
        {
            key: 'replied',
            currentValue: formatReplyRateDisplay(data.totals.replied.count, data.totals.replied.rate),
            diffValue: data.totals.replied.previous,
            teamAverage: userId ? data.totals.replied.teamAverage : undefined
        }
    ];
    return (_jsxs("div", { children: [_jsx(WidgetTitle, { title: t("".concat(i18nPrefix, ".title")), description: "widgetTitleDescriptions.communication.emailSummaryReplyRate", insightType: InsightTypeEnum.emailSummaryReplyRate, insightsData: data, refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t("".concat(i18nPrefix, ".title")), onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, data.periods.map(function (period) {
                                    var _a;
                                    return (_a = {},
                                        _a[t('filters.period')] = period.period,
                                        _a[t("".concat(i18nPrefix, ".series.received"))] = period.received,
                                        _a["".concat(t('export.previous'), " ").concat(t("".concat(i18nPrefix, ".series.received")))] = period.prevReceived,
                                        _a[t("".concat(i18nPrefix, ".series.opened"))] = period.opened,
                                        _a["".concat(t('export.previous'), " ").concat(t("".concat(i18nPrefix, ".series.opened")))] = period.prevOpened,
                                        _a[t("".concat(i18nPrefix, ".series.replied"))] = period.replied,
                                        _a["".concat(t('export.previous'), " ").concat(t("".concat(i18nPrefix, ".series.replied")))] = period.prevReplied,
                                        _a);
                                })];
                        });
                    }); }, disabled: isAiButtonDisabled(data) }) }), _jsx(ChartSeriesVisibility, __assign({ seriesKeys: EMAIL_SUMMARY_REPLY_RATE_KEYS }, { children: function (_a) {
                    var toggleSeries = _a.toggleSeries, isSeriesVisible = _a.isSeriesVisible;
                    return (_jsxs(Widget, __assign({ cardClassName: "shadow overflow-x-auto lg:overflow-visible border-b border-gray-200 sm:rounded-lg p-6", className: "lock w-full max-w-full py-2 align-middle sm:px-6 lg:pl-2 lg:pr-2" }, { children: [_jsx("div", __assign({ className: "mb-6 ml-2 flex flex-wrap justify-start gap-8 rounded-lg p-4 lg:gap-8" }, { children: _jsx("div", __assign({ className: "flex flex-col flex-wrap justify-start gap-2 lg:flex-row lg:gap-4" }, { children: legendItems.map(function (_a) {
                                        var key = _a.key, currentValue = _a.currentValue, diffValue = _a.diffValue, teamAverage = _a.teamAverage;
                                        return (_jsx(LegendItem, { color: EMAIL_SUMMARY_REPLY_RATE_COLORS_CONFIG[key].color, label: t("".concat(i18nPrefix, ".series.").concat(key)), currentValue: currentValue, diffValue: diffValue, teamAverage: teamAverage, arrowColor: TablesDiffColorsConfig.GREEN, onClick: function () { return toggleSeries(key); }, isHidden: !isSeriesVisible(key) }, key));
                                    }) })) })), _jsx(WidgetChartPlotArea, __assign({ isEmpty: chartPlotEmpty }, { children: _jsx(ResponsiveContainer, __assign({ width: "100%", height: 400 }, { children: _jsxs(BarChart, __assign({ data: chartData, barGap: barGap, barSize: barSize, margin: periodBarChartMargin }, { children: [_jsx(CartesianGrid, { strokeDasharray: "3 3", stroke: "#f3f4f6" }), _jsx(XAxis, __assign({ dataKey: "period", axisLine: false, tickLine: false }, periodXAxis, { tickFormatter: function (value) {
                                                    return formatChartDayPeriodAxisLabel(value, interval, {
                                                        dateFrom: dateFrom,
                                                        dateTo: dateTo
                                                    });
                                                } })), _jsx(YAxis, { axisLine: false, tickLine: false, tick: { fontSize: 12, fill: '#6b7280' }, allowDecimals: false }), _jsx(Tooltip, { allowEscapeViewBox: { x: true, y: true }, content: renderTooltip }), EMAIL_SUMMARY_REPLY_RATE_KEYS.map(function (key) { return (_jsx(Bar, { dataKey: key, fill: EMAIL_SUMMARY_REPLY_RATE_COLORS_CONFIG[key].chartColor, hide: !isSeriesVisible(key), onClick: function (barData, index) {
                                                    return handleBarClick(barData, index);
                                                }, style: { cursor: 'pointer' } }, key)); })] })) })) }))] })));
                } }))] }));
};
